/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { useAuth } from "../context/auth/AuthContext";

const normalizePermission = (value) => value === 1 || value === true;

export const ALL_PERMISSIONS = {
  viewOrders: true,
  viewProducts: true,
  createProduct: true,
  editProduct: true,
  deleteProduct: true,
  viewStock: true,

  viewDivisions: true,
  addDivisions: true,
  editDivisions: true,
  deleteDivisions: true,

  viewCategories: true,
  addCategories: true,
  editCategories: true,
  deleteCategories: true,

  viewCustomers: true,
  addCustomers: true,
  editCustomers: true,
  deleteCustomers: true,

  viewBanners: true,
  addBanners: true,
  editBanners: true,
  deleteBanners: true,

  viewTheme: true,
  editTheme: true,

  viewStoreSettings: true,
  editStoreSettings: true,

  viewCoupons: true,
  addCoupons: true,
  editCoupons: true,
  deleteCoupons: true,

  viewActivity: true,
  viewSubscriptions: true,
  editSubscriptions: true,

  viewNotification: true,
  addNotification: true,

  viewPaymentMethods: true,
  addPaymentMethods: true,
  editPaymentMethods: true,
  deletePaymentMethods: true,

  viewShipping: true,
  addShipping: true,
  editShipping: true,
  deleteShipping: true,

  viewInvoice: true,
  editInvoice: true,

  viewAnalytics: true,
  viewSalesReport: true,
  viewInventoryReport: true,
  viewCustomerReport: true,
  viewProductReport: true,

  viewEmployees: true,
  addEmployees: true,
  editEmployees: true,
  deleteEmployees: true,
};

export const useTenantStorePermissions = () => {
  const { authRole, permissions, isTenantOwner } = useAuth();

  let storedPermissions = null;

  try {
    const full = JSON.parse(localStorage.getItem("fullLoginResponse") || "{}");
    storedPermissions = full?.tenantUser || null;
  } catch {
    storedPermissions = null;
  }

  let perms = {};

  if (authRole !== "tenant") {
    perms = {};
  }
  else if (isTenantOwner) {
    perms = ALL_PERMISSIONS;
  }
  else {
    const source =
      permissions && Object.keys(permissions).length > 0
        ? permissions
        : storedPermissions || {};

    perms = Object.keys(ALL_PERMISSIONS).reduce((acc, key) => {
      acc[key] = normalizePermission(source[key]);
      return acc;
    }, {});
  }

  const canAccessPage = (pageKey) => {
    if (authRole !== "tenant") return false;
    if (isTenantOwner) return true;
    if (!pageKey) return true;
    return perms[pageKey] === true;
  };

  return {
    ...perms,
    canAccessPage,
  };
};

